import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { brand, footer } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-line bg-ink py-16" data-id="element-60" data-mp="3ggu1qsai619z">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-61" data-mp="32onkt3zizq9h">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,2fr)]" data-id="element-62" data-mp="32m1cv38q38qq">
          <div data-id="element-63" data-mp="36nd4tff2k623">
            <p className="display text-xl text-cream" data-id="element-64" data-mp="36n3gdw9oa6yi">
              {brand.nameStrong}
              <span className="text-brand-red" data-id="element-65" data-mp="3ucxs2ai99ph6">{brand.nameAccent}</span>
            </p>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-cream/60" data-id="element-66" data-mp="37xvkgeim0i0">{brand.tagline}</p>
            <div className="mt-6 space-y-2 text-sm" data-id="element-67" data-mp="3le2jwsvni5b8">
              <a href={`tel:${brand.phone.replace(/[^\d]/g, '')}`} className="flex items-center gap-2 text-cream/75 transition-colors duration-150 ease-out hover:text-cream" data-id="element-68" data-mp="3qcnk4sawkozo">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-69" data-mp="2ez1iw8rrqwxs" />
                {brand.phone}
              </a>
              <a href={`mailto:${brand.email}`} className="flex items-center gap-2 text-cream/75 transition-colors duration-150 ease-out hover:text-cream" data-id="element-70" data-mp="3l9sj15twaup0">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-71" data-mp="3v91bfu944199" />
                {brand.email}
              </a>
            </div>
          </div>

          <div className="grid gap-8 sm:grid-cols-3" data-id="element-72" data-mp="82idhvaq8efw">
            {footer.columns.map(column => <nav key={column.title} aria-label={column.title} data-id="element-73" data-mp="34gxjj8lkv8n">
                <h2 className="display text-xs tracking-widest text-cream/45" data-id="element-74" data-mp="3231p863ff01">{column.title}</h2>
                <ul className="mt-4 space-y-2.5" data-id="element-75" data-mp="huo5v64w4xvm">
                  {column.links.map(link => <li key={link} data-id="element-76" data-mp="cw3595lq8c6n">
                      <a href="#top" className="text-sm text-cream/75 transition-colors duration-150 ease-out hover:text-cream" data-id="element-77" data-mp="qsqdw5n1kqse">
                        {link}
                      </a>
                    </li>)}
                </ul>
              </nav>)}
          </div>
        </div>

        <p className="mt-14 border-t border-line pt-6 text-xs text-cream/45" data-id="element-78" data-mp="13tkde1wj87cx">{footer.copyright}</p>
      </div>
    </footer>;
}